import Loadable from '../../components/loadable';

const BulkImportMembershipPlansDropdown = Loadable({
  loader: () => import('../../pages/bulk_imports/bulk_import_membership_plans_dropdown'),
});

angular.module('gym').value('BulkImportMembershipPlansDropdown', BulkImportMembershipPlansDropdown);
